export const createNewTab = (
  value: string,
  label: string,
  idContract: string,
  customerCode: string,
  customerVersion: number,
  contractType: number,
  contractKind: number,
  groupDomainCode: string,
  divisionId?: number
) => {
  return {
    value: value,
    label: label + (contractKind == 4 ? ' - Master' : ''),
    sellingContractId: idContract,
    customerCode: customerCode,
    customerVersion: customerVersion,
    contractType: contractType,
    contractKind: contractKind,
    groupDomainCode: groupDomainCode,
    divisionId: divisionId
  }
}
